import React from 'react';
import { Info, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { BLOCKS } from './nodes';

/** Block library, ported from the DialFlow prototype sidebar. Drag a block onto the canvas, or click to add it. */
export default function Palette({ onAdd, readOnly, collapsed = false, onToggle }) {
  const onDragStart = (event, type) => {
    event.dataTransfer.setData('application/reactflow', type);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <aside className={`flow-sidebar ${collapsed ? 'collapsed' : ''}`}>
      {onToggle && (
        <button type="button" className="palette-toggle" onClick={onToggle} aria-expanded={!collapsed}
          aria-label={collapsed ? 'Show the block list' : 'Hide the block list'} title={collapsed ? 'Show the block list' : 'Hide the block list'}>
          {collapsed ? <PanelLeftOpen size={16} /> : <PanelLeftClose size={16} />}
        </button>
      )}
      {!collapsed && (
        <div className="sidebar-title">
          <h3>CALL FLOW BLOCKS</h3>
          <p>{readOnly ? 'Only the company owner can change call flows' : 'Drag blocks onto the canvas, or click to add'}</p>
        </div>
      )}

      <div className="blocks-container">
        {BLOCKS.map((block) => {
          const Icon = block.icon;
          const disabled = readOnly || block.soon;
          return (
            <div
              key={block.type}
              className={`draggable-block-card relative-block-card ${block.soon ? 'soon' : ''}`}
              style={{ borderLeftColor: block.borderColor, '--hover-bg': block.color }}
              draggable={!disabled}
              onDragStart={(e) => onDragStart(e, block.type)}
              onClick={() => !disabled && onAdd(block.type)}
              role="button"
              tabIndex={disabled ? -1 : 0}
              aria-disabled={disabled}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && !disabled && onAdd(block.type)}
              title={block.soon ? 'Coming soon' : `Add ${block.label}`}
            >
              <div className="block-icon-wrapper" style={{ backgroundColor: block.color }}>
                <Icon size={18} style={{ color: block.borderColor }} />
              </div>
              {!collapsed && (
                <div className="block-details">
                  <span className="block-label text-ellipsis">{block.label}{block.soon && <span className="soon-chip">Coming soon</span>}</span>
                  <span className="block-desc">{block.description}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {!collapsed && <div className="sidebar-explanation">
        <div className="explanation-header"><Info size={14} className="info-icon" /><span>How to set up a call flow</span></div>
        <ol className="explanation-steps">
          <li>Start from <strong>Call Comes In</strong> and choose which number it answers.</li>
          <li>Connect a block's <strong>right dot</strong> to the next block's <strong>left dot</strong>.</li>
          <li>Test it with <strong>Simulate Call</strong>, which costs nothing.</li>
          <li><strong>Publish</strong> to answer real calls with this flow.</li>
        </ol>
      </div>}
    </aside>
  );
}
